import { Routes } from '@angular/router';
import {PrenotazioneCreateComponent} from "./prenotazione-create/prenotazione-create.component";

export const routes: Routes = [
  { path: '', component: PrenotazioneCreateComponent},
  { path: 'create/:id_prestazione', component: PrenotazioneCreateComponent },
];
